<template>
	<header>
      <nav>
	    <h1 id="logo_monito">Monito</h1>
	    <ul>
          <li><a href="#">About us</a></li>
          <li><a href="#">Providers</a></li>
          <li><a href="#">Alerts</a></li>
          <li><a href="#">Wiki</a></li>
          <li class="langage"><a href="#">EN</a></li>
        </ul>
      </nav>
      
      <section class="form shadow">
      <div class="from country">
        <span class="label">Sending From</span>
        <span>United Kingdom</span>
      </div>

      <div class="to country">
        <span class="label">Sending to</span>
        <span>France</span>
      </div>

      <div class="amount from active">
		<span>1,200</span><span class="currency">GBP</span>
	  </div>
	
	  <div class="amount to">
		<span>1,397</span><span class="currency">EUR</span>
	  </div>
	  
	  <div class="button shadow">Compare</div>
	</section>
	<div class="hero_element" style="height: 620px;"></div>
  </header>


</template>
<script>
	export default {
      data(){
      	return{
      		form : false	
      	};
      }
  }
</script>

<style lang="scss">

body {
    position: relative;
    background : #F8F8F8;
    font-family:Avenir Next,-apple-system,system-ui,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif,BlinkMacSystemFont,Helvetica Neue,Arial;
    box-sizing: border-box;
    padding: 0;
    color: #353C45;
    max-width: 100vw;
    overflow-x: hidden;
    margin: 0;
}

header {
    border-top: 3px solid #8cc42d;
    position: relative;
    z-index: 1000;

    &:before {
        content: '';
        position: absolute;
        z-index: -1;
        top: -927px;
        background: #fff;
        width: 5452px;
        height: 1050px;
        left: calc(((5452px - 100vw) / 2) * -1);
         -webkit-border-radius: 150% /95%;
        -moz-border-radius:    150% / 95%; 
        border-radius:         150% / 95%;
        -webkit-box-shadow: 0px 3px 20px 0px rgba(0,0,0,0.1);
        -moz-box-shadow: 0px 3px 20px 0px rgba(0,0,0,0.1);
        box-shadow: 0px 3px 20px 0px rgba(0,0,0,0.1);
    }

    &:after {
      content: '';
      position: absolute;
      z-index: 3000px;
      left: 0;
      height: 3px;
      background-color: #8cc42d; 
      width: 100vw;
      top: -3px;
    }

    .hero_element {
       
        z-index: -10;
        position: absolute;
        width: 100%;
        top: 0;
        height: 600px;
        /*background: #81CA00;*/
        background-image: linear-gradient(to right, #81ca00, #8cce02, #97d304, #a2d707, #addb0c);
        
        div {
            width: 1200px;
            padding-right: 30%;
            box-sizing: border-box;
            margin: 0 auto;
            position: relative;
            &:after {
                content:'';
                width: 200px;
                height: 100px;
                left: 590px;
                bottom: -120px;
                //background-image: url('../assets/arrow_looping_hero.png');
                display: block;
                position: absolute;
                background-size: contain;
                background-repeat: no-repeat;
            }
        }

        h1 {
            color: #fff;
        }

        &:after {
        content: '';
        position: absolute;
        z-index: -2;
        transform: rotate(-2.6deg);
        display: block;
        width: 120%;
        height: 200px;
        bottom: -100px;
        left: -20px;
        /*background: #81CA00;*/
        background: #f8f8f8;   
        }
    }

    
}  

.shadow {
    box-sizing:border-box;
    -webkit-box-shadow: 0px 3px 20px 0px rgba(0,0,0,0.1);
    -moz-box-shadow: 0px 3px 20px 0px rgba(0,0,0,0.1);
    box-shadow: 0px 3px 20px 0px rgba(0,0,0,0.1);
}

.soft_shadow {
    -webkit-box-shadow: 0px 3px 20px 0px rgba(0,0,0,0.03);
    -moz-box-shadow: 0px 3px 20px 0px rgba(0,0,0,0.03);
    box-shadow: 0px 3px 20px 0px rgba(0,0,0,0.03);
}

nav, main {
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    overflow: clip;
}

nav {
    display: flex;
    justify-content: space-between;
    align-content: center;
    margin-top: 31px;
    margin-bottom: 72px;

    #logo_monito {
        display: inline-block;
        text-indent: -1000px;
        font-size: 1px;
        background-image:url('../assets/monito_logo.svg');
        background-repeat: no-repeat;
        width: 190px;
        margin-left: 12px;
        height: 52px;
        background-size: contain;
        background-position: center;
        z-index: 100;
        vertical-align: middle;
    }
    ul {
        display: inline-block;
        list-style: none;
        li {
            display: inline-block;
            padding: 0 36px;

            &:last-child{
                padding-right: 10px;
            }

            a {
                text-decoration: none;
                color: #cdcdcd;
                font-size: 12px;
                color: #6f747a;
                font-family:Avenir Next,-apple-system,system-ui,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif,BlinkMacSystemFont,Helvetica Neue,Arial;
                font-weight: 700;
                letter-spacing: 0.045em;
                text-transform: uppercase;

            }

            &.langage {
                a {
                    color: #000;
                }		
                
                &:after {
                    content: '';
                    background-image: url('../assets/arrow_down.svg');
                    background-position: top;
                    margin-left: 3px;
                    background-repeat: no-repeat;
                    background-size: contain;
                    width: 10px;
                    height: 8px;
                    display: inline-block;
                }
            }

            &:hover {
                a {
                    transition: all 0.3s ease;
                    color: #000;
                }
            }
        }
    }

}



.form {
    flex: none;
    width: 1260px;

    margin: 0 auto;
    margin-top: 82px;
    margin-bottom: 48px;
    display:block;
    background: #fff;
    height: 80px;
    border-radius: 10px;
    left: calc(((100vw - 1260px) / 2) * 1 );

    .country {
        width: 265px;
        display: inline-block;
        padding-left: 25px;
        position: relative;
        height :80px;
        border-right: 4px solid #F4F4F4;


        &:after {
            content:'';
            display: block;
            position: absolute;
            right: 23px;
            top: 43px;
            width: 15px;
            height: 10px;
            background-image: url('../assets/arrow_form.svg');
            background-repeat: no-repeat;
            background-size:contain;
        }

            span:not(.label){
                padding-top: 4px;
                &:before {
                    display: inline-block;
                    content: '';
                    position: relative;
                    top: -3px;
                    padding-right: 10px;
                    left: -4px;
                    width: 28px;
                    height: 23px;
                    background-image: url('../assets/flag_uk.png');
                    background-position: center;
                    background-size: contain;
                    background-repeat: no-repeat;
                    vertical-align: middle;
                }
            }

            &.to {
                span:not(.label){
                    &:before {
                        background-image: url('../assets/flag_france.png');
                    }
                }
            }
        

        span {
            display: block;
            letter-spacing: 0.03em;
            font-size: 19px;
            font-family: 'Avenir Next';
            font-weight: 700;
            color: #353C45;

            &:not(.label) {
                
            }

            &.label {
                padding-top: 15px;
                padding-bottom: 2px;
                text-transform: uppercase;
                font-size: 11px;
                font-family:Avenir Next,-apple-system,system-ui,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif,BlinkMacSystemFont,Helvetica Neue,Arial;
                font-weight: 700;
                color: #797e83cf;
                letter-spacing: 0.045em;
            }
        }


    &.usa {span:not(.label){ &:before {background-image: url('../assets/flag_usa.png');}}}
    &.phil {span:not(.label){ &:before {background-image: url('../assets/flag_phil.png');}}}
    &.nz {span:not(.label){ &:before {background-image: url('../assets/flag_new_zealand.png');}}}
    &.fr {span:not(.label){ &:before {background-image: url('../assets/flag_france.png');}}}
    &.cam {span:not(.label){ &:before {background-image: url('../assets/flag_cameroun.png');}}}
    &.aus {span:not(.label){ &:before {background-image: url('../assets/flag_aus.png');}}}
    &.sgp {span:not(.label){ &:before {background-image: url('../assets/flag_sgp.png');}}}
    &.ind {span:not(.label){ &:before {background-image: url('../assets/flag_ind.png');}}}


    &.chf {span:not(.label){ &:before {background-image: url('../assets/flag_swiss.png');width: 23px;padding-right: 9px;}}}


    }

    .amount {

        display:inline-block;
        box-sizing: border-box;
        padding-top: 12px;
   
        position: relative;
        vertical-align: middle;
        margin: 0 20px 22px 20px;
        height: 54px;
        width: 184px;
        border: 3px solid #E4E4E4;
        font-size: 18px;
        font-family: 'Avenir Next';
        font-weight: 700;
        border-radius: 6px;
        span:not(.currency ){
            padding-left: 13px;
            color: rgba(53,60,69,0.5);
        }

        &.from {
            position: relative;
            margin-right: 30px;
            &:after {
                content:'TO';
                font-size: 12px;
                font-family: 'Avenir Next';
                font-weight: 700;
                color: #797e83cf;
                letter-spacing: 0.045em;
                right: -40px;
                top: 16px;
                position: absolute;
            }
        }

        &.active {
            border-color: #79ca0c;
            span:not(.currency ){
                color: #353C45;
            }   
            padding-left: 0;

            span:not(.currency) {
                &:before {
                   display:none;
                }
            }
        }

        .currency {
            font-size: 16px;
            position: relative;

            &:after {
                content:'';
                display: block;
                position: absolute;
                right: -20px;
                top: 6px;
                width: 13px;
                height: 8px;
                background-image: url('../assets/arrow_form.svg');
                background-repeat: no-repeat;
                background-size:contain;
            }
        }

        span:not(.currency) {
             &:before {
                content:'~';
                position: relative;
                left: -5px;
            }
            display: inline-block;
            width: 115px;
            box-sizing: border-box;
            padding-left: 20px;
            position: relative;

            &:after {
                content:'';
                display: block;
                position: absolute;
                width: 2px;
                height: 28px;
                background: #e8e6e6;
                right: 10px;
                top: -1px;
            }
        }
    }

    .button {
        display:inline-block;
        background: #ff9a00;;
        cursor: pointer;
        border-radius: 6px;
        height: 56px;
        width: 180px;
        color: #fff;
        vertical-align: top;
        margin-top: 12px;
        box-sizing: border-box;
        font-size: 18px;
        text-align: center;
        padding-top: 16px;
        letter-spacing: 0.035em;
        font-family: 'Avenir Next';
        font-weight: 600;

    }
}


</style>

<!--<div>d
		deded
		<ul v-if="dataFetch" >
      <transition-groupe name="list">
        <li v-for="(result,index) in sortedArray" :key="index" v-show="choicePayIn(Object.keys(result.options.sending)[0],result.psp_id)"> {{ getPspName(result.psp_id) }}<span style=" font-size: 18px; font-weight: bold; display: inline-block;margin: 0 20px;">{{ virgule_rec(result.costs.total_received_destination) }}</span><span style="font-weight: bold;  font-size: 14px; ">{{ virgule(result.costs.total_fees) }}</span> {{ Object.values(result.options.sending)[0] }} {{ result.transfer_time_product_rate}}</li>
      </transition-groupe>
    </ul>

    {{ test() }}

    <div id="list-complete-demo" class="demo">
  <button v-on:click="shuffle">Mélanger</button>
  <button v-on:click="add">Ajouter</button>
  <button v-on:click="remove">Enlever</button>
  <transition-group name="list-complete" tag="p">
    <span
      v-for="item in items"
      v-bind:key="item"
      class="list-complete-item"
    >
      {{ item }}
    </span>
  </transition-group>
	</div>
	</div>-->


// WEBPACK FOOTER //
// src/components/Header.vue